import React from "react";

import { Icon, IconTypeEnum } from "@components/common/icon";

import ExpertBadge from "../expertBadge";
import { IS_PROD, toWebpSrcSet } from "../image/webp";

import { UserAvatarProps } from "./types";

import "./styles.scss";

export const UserAvatar = ({
  mobileImage,
  desktopImage,
  name,
  // userId,
  type,
  expertCategory,
  badgeText,
}: UserAvatarProps) => {
  if (mobileImage?.twox && desktopImage?.twox) {
    return (
      <div className="user-avatar__picture-wrapper">
        {expertCategory && (
          <div className="user-avatar__badge-top">
            <ExpertBadge ExpertBadgeData={expertCategory} />
          </div>
        )}
        <picture
          className={`user-avatar user-avatar--${type ?? "default"}`}
        >
          {/* webp-source'ы (#11) — только для локальных картинок из манифеста, в прод-сборке */}
          {IS_PROD && (() => {
            const mobileWebp = toWebpSrcSet(`${mobileImage.twox}, ${mobileImage.twox} 2x, ${mobileImage.threex} 3x`);
            const desktopWebp = toWebpSrcSet(`${desktopImage.twox}, ${desktopImage.twox} 2x, ${desktopImage.threex} 3x`);
            return (
              <>
                {mobileWebp && <source srcSet={mobileWebp} media="(max-width: 767px)" type="image/webp" />}
                {desktopWebp && <source srcSet={desktopWebp} media="(min-width: 768px)" type="image/webp" />}
              </>
            );
          })()}
          <source
            srcSet={`${mobileImage.twox},
              ${mobileImage.twox} 2x,
              ${mobileImage.threex} 3x`}
            media="(max-width: 767px)"
          />
          <source
            srcSet={`${desktopImage.twox},
              ${desktopImage.twox} 2x,
              ${desktopImage.threex} 3x`}
            media="(min-width: 768px)"
          />
          <img src={mobileImage.twox || ""} alt={name || ""} width="176" height="176" loading="lazy" decoding="async" />
          {badgeText && (
          <div className="user-avatar__badgeText-container">
            <p>{badgeText}</p>
          </div>
          )}
        </picture>
      </div>
    );
  }

  return (
    <div className={`user-avatar user-avatar--empty user-avatar--${type ?? "default"}`}>
      <Icon type={IconTypeEnum.User} />
    </div>
  );
};
